var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71746 10.9307C4.59812 10.8179 4.45774 10.7297 4.30433 10.6712C4.15092 10.6127 3.98748 10.585 3.82335 10.5896C3.65923 10.5942 3.49762 10.6312 3.34776 10.6983C3.19791 10.7654 3.06273 10.8613 2.94996 10.9807C2.83719 11.1 2.74902 11.2404 2.6905 11.3938C2.63199 11.5472 2.60426 11.7106 2.6089 11.8748C2.61354 12.0389 2.65047 12.2005 2.71756 12.3504C2.78466 12.5002 2.88062 12.6354 2.99996 12.7482L14.25 23.3732C14.482 23.5926 14.7893 23.7148 15.1087 23.7148C15.4281 23.7148 15.7354 23.5926 15.9675 23.3732L27.2187 12.7482C27.3407 12.6361 27.4391 12.501 27.5084 12.3506C27.5777 12.2002 27.6164 12.0375 27.6223 11.872C27.6282 11.7065 27.6011 11.5415 27.5427 11.3866C27.4842 11.2316 27.3956 11.0898 27.2819 10.9694C27.1682 10.849 27.0317 10.7524 26.8804 10.6852C26.729 10.618 26.5658 10.5815 26.4003 10.5779C26.2347 10.5743 26.0701 10.6036 25.916 10.6642C25.7618 10.7248 25.6213 10.8153 25.5025 10.9307L15.1087 20.7457L4.71746 10.9307Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatArrowIcon);
export default __webpack_public_path__ + "static/media/chat-arrow-icon.42c71891a870ae8db28925a7fa95a22d.svg";
export { ForwardRef as ReactComponent };